export const routes = [
  {
    path: '/cidade/:id/relatorio-administrativo',
    component: () => import(/* webpackChunkName: "administrative-report" */ './components/List'),
    name: 'administrative.report.list',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/relatorio-administrativo/inserir',
    component: () => import(/* webpackChunkName: "administrative-report" */ './components/Insert'),
    name: 'administrative.report.insert',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/cidade/:id/relatorio-administrativo/obter/:relatorio',
    component: () => import(/* webpackChunkName: "administrative-report" */ './components/Get'),
    name: 'administrative.report.get',
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/analisar-relatorios-administrativos',
    component: () => import(/* webpackChunkName: "administrative-report" */ './components/Analyse'),
    name: 'administrative.report.analyse',
    meta: {
      requiresAuth: true
    }
  }
]
